import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ConfigProvider } from "../../../config-provider.service";
import { MobileSidenavService } from '../mobile-header/mobile.sidenav.service';
import { MatSidenav } from '@angular/material/sidenav';
import { delay } from 'rxjs/operators';
import { LoadingService } from '../../providers/loading.service';
import { FullWidthLoaderComponent } from "../full-width-loader/full-width-loader";
import { NgIf } from "@angular/common";

@Component({
  selector: 'mobile-page-content',
  providers: [MobileSidenavService],
  styleUrls: ['./mobile-page-content.scss'],
  standalone: true,
  imports: [
    FullWidthLoaderComponent,
    NgIf
  ],
  templateUrl: './mobile-page-content.html'
})
export class MobilePageContentComponent implements OnInit {

    @Input() public fullPageWidth = false;
    @Input() public hasHeader = true;

    public loading = false;

    @ViewChild('navigationSidenav', {static: false}) public navigationSidenav: MatSidenav = {} as MatSidenav;

    constructor(
        public conf: ConfigProvider,
        private sidenavService: MobileSidenavService,
        private _loading: LoadingService
    ) {
    }

    public ngOnInit(): void {
        this.listenToLoading();
    }

    /**
     * Listen to the loadingSub property in the LoadingService class. This drives the
     * display of the loading spinner.
     */
    private listenToLoading(): void {
        this._loading.loadingSub
            .pipe(delay(0)) // This prevents a ExpressionChangedAfterItHasBeenCheckedError for subsequent requests
            .subscribe((loading: boolean) => {
                this.loading = loading;
            });
    }
}
